let pageContext = {};

exports.GlobalPageContext = {
  get: () => {
    return pageContext;
  },
  set: (newPageContext) => {
    pageContext = newPageContext;
  },
};
